import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";
import {ACCEPTED, ACTION_STATUS_COLORS, DECLINED, PENDING, TENTATIVE} from "./constants";

export const ParticipationStatus = styled(Box)`
    height: 15px;
    width: 15px;
    background-color: ${(props) => ACTION_STATUS_COLORS[props.status]};
    border-radius: 50%;
    margin-left: .4rem;
    display: inline-block;
  `;

export const findExternalEvent = (action, events, job) => {
    const event = events?.find(e => e.event_id === action?.opportunity_action_invite_uuid);

    if (event) {
        const {attendees} = event;
        const statusAccepted = attendees.some(e => e.status === ACCEPTED.toLowerCase() && e.email === job?.job_email);
        const statusDeclined = attendees.some(e => e.status === DECLINED.toLowerCase() && e.email === job?.job_email);
        const statusTentative = attendees.some(e => e.status === TENTATIVE.toLowerCase() && e.email === job?.job_email);

        if (statusAccepted)
            event['event_status_overall'] = ACCEPTED;
        else if (statusDeclined)
            event['event_status_overall'] = DECLINED;
        else if (statusTentative)
            event['event_status_overall'] = TENTATIVE
        else
            event['event_status_overall'] = PENDING;
    }

    return event;
}